import React from 'react';
import { PaymentLogos } from './PaymentLogos';
export function PaymentSection() {
  return <section className="w-full bg-zinc-950/30" data-id="element-104">
      {/* Top gold separator */}
      <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-[#C5A014]/40 to-transparent" data-id="element-105" />

      <div className="max-w-2xl mx-auto py-24 px-4" data-id="element-106">
        <div className="text-center space-y-8" data-id="element-107">
          {/* Pricing */}
          <div className="py-6 border-y border-zinc-800 space-y-2" data-id="element-108">
            <div className="font-['Playfair_Display'] font-bold text-6xl md:text-7xl text-[#C5A014]" data-id="element-109">
              6.99 USD
            </div>
            <p className="font-['Crimson_Text'] text-lg text-[#C5A014]/80 italic tracking-wide" data-id="element-110">
              Precio de lanzamiento
            </p>
          </div>

          {/* CTA Button */}
          <a href="https://templeofpages.com/checkouts/cn/hWN9tQ5DtgSWWrpyJygis6de/es-us?_r=AQABmVpcacgZYb5zSd4A0a6A2wtwNLfkCHW8pMOOTZHrBLM" target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-[#B8860B] text-black font-['Playfair_Display'] font-bold text-xl md:text-2xl lg:text-3xl py-6 hover:bg-[#C5A014] transition-all duration-300 shadow-lg hover:shadow-[0_0_40px_rgba(184,134,11,0.3)] hover:scale-[1.02] no-underline" aria-label="Comprar ahora por 10 dólares" data-id="element-111">
            QUIERO LEER EL LIBRO AHORA
          </a>

          {/* Payment Methods */}
          <PaymentLogos data-id="element-112" />

          {/* Urgency */}
          <p className="font-['Crimson_Text'] text-sm md:text-base text-zinc-400" data-id="element-113">
            ⏳ Precio de lanzamiento disponible por tiempo limitado
          </p>

          {/* Trust Badges */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 pt-2" data-id="element-114">
            <div className="flex items-center gap-2 text-zinc-400" data-id="element-115">
              <span className="text-lg" data-id="element-116">✅</span>
              <span className="font-['Crimson_Text'] text-sm md:text-base" data-id="element-117">
                Descarga inmediata
              </span>
            </div>
            <div className="flex items-center gap-2 text-zinc-400" data-id="element-118">
              <span className="text-lg" data-id="element-119">📱</span>
              <span className="font-['Crimson_Text'] text-sm md:text-base" data-id="element-120">
                Compatible con cualquier dispositivo
              </span>
            </div>
            <div className="flex items-center gap-2 text-zinc-400" data-id="element-121">
              <span className="text-lg" data-id="element-122">🔒</span>
              <span className="font-['Crimson_Text'] text-sm md:text-base" data-id="element-123">
                Pago 100% seguro
              </span>
            </div>
          </div>

          {/* Format */}
          <p className="font-['Crimson_Text'] text-sm text-zinc-500 pt-2" data-id="element-124">
            Formato: PDF · Acceso inmediato tras la compra
          </p>
        </div>
      </div>

      {/* Bottom gold separator */}
      <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-[#C5A014]/40 to-transparent" data-id="element-125" />
    </section>;
}